import React from 'react';
import moment from 'moment';
import { ChatService } from 'services';
import { classes, Constants, Globals } from 'utils';
import { CloseIcon, UserIcon, DocumentIcon, PDFIcon, DownloadIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ViewChat extends React.Component<Props> {

	messagesEnd: any = null;

	state = {
		chat: null,
		messages: []
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutScroll = false) => {
		const res: any = await ChatService.admin.view({
			chat_id: this.props.item?.id
		});
		this.setState({
			chat: res.chat,
			messages: res.messages || []
		}, () => {
			if (!withoutScroll) {
				this.scrollToBottom();
			}
		});
	}

	scrollToBottom = () => {
		this.messagesEnd.scrollTo({
			behavior: 'smooth',
			top: this.messagesEnd.scrollHeight
		});
	}

	getFile = (file: any) => {
		const imageMatch = /\.(jpg|jpeg|png|gif|bmp|webp|svg)(\?|#|$)/i;
		let image = DocumentIcon;
		let style = 'file-document'

		const isPDF = String(file).endsWith('.pdf');
		const isImage = imageMatch.test(file);

		if (isPDF) image = PDFIcon;

		if (isImage) {
			image = Globals.fromPhotos(file);
			style = 'file-image';
		}

		return { image, style };
	}

	downloadFile = (file: any) => {
		if (!file) return;
		const extenstion = Globals.getFileExtension(file);
		const link = document.createElement('a');
		link.href = Globals.fromStorage(file);
		link.download = `file.${extenstion}`;
		link.target = '_blank';
		link.click();
		link.remove();
	}

	render() {
		const chat: any = this.state.chat;

		return (
			<div id="admin-view-chat">
				<div className="header-modal">
					{
						chat != null && (
							<div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
								<div className="container-images-modal">
									{chat?.user?.photo ? (
										<img src={Globals.fromPhotos(chat.user.photo)} alt="Foto" className="image-modal" />
									) : (
										<img src={UserIcon} alt="Foto" className="placeholder-image-modal" />
									)}
									{chat?.doctor?.photo ? (
										<img src={Globals.fromPhotos(chat.doctor.photo)} alt="Foto" className="image-modal" />
									) : (
										<img src={UserIcon} alt="Foto" className="placeholder-image-modal" />
									)}
								</div>
								<p>Chat {chat?.user?.full_name} y {chat?.doctor?.full_name}</p>
							</div>
						)
					}
					<button className="btn-close" onClick={() => this.props.onClose()}>
						<img src={CloseIcon} alt="Cerrar" />
					</button>
				</div>
				<div className="container-scroll-modal-right" ref={(el) => { this.messagesEnd = el; }}>
					<div className="container-messages">
						{
							this.state.messages.map((item: any) => {
								const is_right = item.user?.level_id === Constants.LEVELS.PATIENT;
								const className = is_right ? 'text-right' : 'text-left';
								let src = '';
								let style = '';

								if (item.file) {
									src = this.getFile(item.file).image;
									style = this.getFile(item.file).style;
								}

								return (
									<div className={`message ${is_right ? 'right' : ''}`} style={{ alignSelf: is_right ? 'flex-end' : 'flex-start' }}>
										<p className="name" style={{ textAlign: is_right ? 'right' : 'left' }}>{item.user?.full_name}</p>
										{
											item.message
												? <p className={className}>{item.message}</p>
												: <div className={classes(className, 'file')} onClick={() => this.downloadFile(item.file)}>

													<img src={src} alt="Archivo adjunto" onError={(e: any) => e.target.src = DocumentIcon} className={style} />
													<p>Archivo adjunto </p>
													<p className="filename">({item.file?.split('.').pop()})</p>
													<img src={DownloadIcon} alt="Descargar archivo" className="download" />

												</div>
										}
										{
											moment(item.created_at).isValid() && (
												<p className="date" style={{ textAlign: is_right ? 'left' : 'right' }}>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</p>
											)
										}
									</div>
								)
							})
						}
					</div>
				</div>
			</div>
		)
	}
}

export default ViewChat;